export default __webpack_public_path__ + "static/media/about.58063da1.png";